// Mint-JobNew start=chat: Ask HANA đọc tin nhắn chat → các ô điền sẵn + kiểm trùng (chép logic parseChat / dupsOf từ script board). Dữ liệu mẫu, chưa ghi.
import { CUS, PORT, type FormValues } from './newForm';

export const CHAT_SAMPLE =
  'MAITTN (chat Ask HANA, 09:40): MKAGRISEA cần 1x40RH VNVUT → SAJED tàu WAN HAI 622 W028, -18°C, booking WHL 039GY17759, ETD 02/11, ref PO-MK-2610.';

const CS = ['HOATTN', 'MAITTN', 'ThuyNTT', 'ThuongLVH'];
const BKG_OWNER: Readonly<Record<string, string>> = { SAVITA: 'PhuongHT', COCOGROUP: 'NhiTHT', GREENBUD: 'PHUONGNKT', MKAGRISEA: 'PhuongHT', QUEKYCORP: 'PHUONGNKT', 'GNP IMEX': 'PHUONGNKT', TAMNGOC: 'PhuongHT', NEWWIND: 'TranTPB' };

export const CHAT_CHIP_LABEL: Readonly<Record<string, string>> = { cus: 'Khách', vol: 'Số cont', tcont: 'Loại cont', pol: 'POL', pod: 'POD', carrier: 'Hãng', vsl: 'Tàu', bkno: 'BookingNo', etd: 'ETD', temp: 'Nhiệt độ', cref: 'Ref khách', contno: 'Container' };

export function parseChat(msg: string): Record<string, string> {
  const U = String(msg || '');
  const o: Record<string, string> = {};
  const cus = CUS.find((c) => U.toUpperCase().includes(c));
  if (cus) o.cus = cus;
  const q = /(\d+)\s*[x×]\s*(\d{2}[A-Z]{2})/i.exec(U);
  if (q) {
    o.vol = q[1]!;
    o.tcont = q[2]!.toUpperCase();
    o.tship = 'FCL';
    o.tcargo = /R[FH]$/i.test(q[2]!) ? 'RF · hàng lạnh' : 'DC · hàng khô';
  }
  const rt = /([A-Z]{5})\s*(?:→|->|-|to)\s*([A-Z]{5})/.exec(U);
  if (rt) {
    o.pol = PORT.find((p) => p.startsWith(rt[1]!)) ?? rt[1]!;
    o.pod = PORT.find((p) => p.startsWith(rt[2]!)) ?? rt[2]!;
  }
  const bk = /booking\s+(?:([A-Z]{3})\s+)?([A-Z0-9]{8,})/i.exec(U);
  if (bk) {
    if (bk[1]) o.carrier = bk[1].toUpperCase();
    o.bkno = bk[2]!;
    o.bstatus = 'BK Confirmed';
  }
  const vs = /tàu\s+([A-Z0-9][A-Z0-9 -]+?)\s*(?:,|\.|$)/i.exec(U);
  if (vs) o.vsl = vs[1]!.trim();
  const et = /ETD\s*(\d{1,2})\/(\d{1,2})/i.exec(U);
  if (et) o.etd = `${et[1]!.padStart(2, '0')}/${et[2]!.padStart(2, '0')}/2026`;
  const tp = /(-\d+)\s*°?\s*C/i.exec(U);
  if (tp) o.temp = tp[1]!;
  const rf = /ref\s+([A-Z0-9-]+)/i.exec(U);
  if (rf) o.cref = rf[1]!;
  const ct = /\b([A-Z]{4}\d{7})\b/.exec(U);
  if (ct) o.contno = ct[1]!;
  const by = /^([A-Za-z]+)\s*\(/.exec(U);
  if (by && CS.includes(by[1]!)) o.cs = by[1]!;
  if (o.cus) {
    o.bkg = BKG_OWNER[o.cus] ?? '';
    o.sale = o.sale ?? 'PHILIP';
  }
  return o;
}

export const chatChips = (p: Readonly<Record<string, string>>): string[] =>
  Object.entries(p).filter(([k]) => k in CHAT_CHIP_LABEL).map(([k, val]) => `${CHAT_CHIP_LABEL[k]}: ${val.split(' · ')[0]}`);

export interface Dup { key: string; val: string; job: string; ss: string; hard: boolean }

// [job, khách, BookingNo, HBL/MBL, container, tàu, POD, ref khách, ShipmentStatus]
const EX: ReadonlyArray<readonly string[]> = [
  ['SE260639370', 'MKAGRISEA', '039GY17759', 'HNSGN260639370', 'WHLU4012345', 'WAN HAI 622 W028', 'SAJED', 'PO-MK-2610', 'BK Standby'],
  ['SE260613890', 'EMDEES', 'SGNGZ2181600', 'HNSGN260613890', 'TLLU1145427', 'SINAR SANUR 152S', 'GBSOU', '', 'BL Hold'],
  ['SE260639540', 'SAVITA', 'ASC0549348', 'HNSGN260639540', 'CNCU4019652', 'HUI ZHOU JIN HAI KI8070N89', 'KRPUS', 'SV-2610-07', 'BK Confirmed'],
  ['SE260636780', 'GREENBUD', 'A59GX35041', 'HNSGN260636780', 'IAAU4031570', 'WAN HAI 296 N064', 'JPTYO', '', 'BL Wait RLS'],
  ['SE260639520', 'COCOGROUP', '', 'HNSGN260639520', '', 'TIDE CAPTAIN 2621N', 'CNNSA', '', 'RQ Standby'],
];
const norm = (s: string) => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/đ/g, 'd');
const eq = (a?: string, b?: string) => !!a && !!b && norm(a).replace(/\s+/g, '') === norm(b).replace(/\s+/g, '');

/** Kiểm trùng nhiều khoá: BookingNo · HBL/MBL · container · Ref khách · khách + tàu + POD. */
export function dupsOf(x: FormValues | Readonly<Record<string, string>>): Dup[] {
  const out: Dup[] = [];
  for (const e of EX) {
    const [job, cus, bkn, hbl, cont, vsl, pod, ref, ss] = e as [string, string, string, string, string, string, string, string, string];
    if (eq(x.bkno, bkn)) out.push({ key: 'BookingNo', val: bkn, job, ss, hard: true });
    else if (eq(x.bkno, hbl)) out.push({ key: 'HBL / MBL', val: hbl, job, ss, hard: true });
    if (eq(x.contno, cont)) out.push({ key: 'Container', val: cont, job, ss, hard: true });
    if (eq(x.cref, ref)) out.push({ key: 'Ref khách (CustomerReference)', val: ref, job, ss, hard: false });
    if (x.cus === cus && eq(x.vsl, vsl) && (x.pod ?? '').startsWith(pod)) out.push({ key: 'Khách + tàu + POD', val: `${cus} · ${vsl} · ${pod}`, job, ss, hard: false });
  }
  return out;
}
